import { render, staticRenderFns } from "./ChevronRight24px.vue?vue&type=template&id=917df352&"
import script from "./ChevronRight24px.vue?vue&type=script&lang=js&"
export * from "./ChevronRight24px.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports